/* color-swatch-scroll.js (mobile only + debug + hard fallback) */
(function () {
  const MOBILE_BP = 768; // 未満=スマホ
  const OFFSET_PX = 0;   // 固定ヘッダーがある場合は高さを入れる（例：80）
  const DEBUG = false;   // ログを出すときは true

  const GALLERY_TARGETS = [
    '#MediaGallery', '#MainProductMedia',
    '.product__media-wrapper', '.product-gallery',
    '.Product__Gallery', '.ProductGallery', '.Product__Media'
  ];

  const isMobile = () => window.matchMedia(`(max-width:${MOBILE_BP - 1}px)`).matches;
  const log = (...a) => { if (DEBUG) console.log('[swatch-scroll]', ...a); };

  // 商品カード（関連商品・最近見た商品など）のスウォッチは対象外にする。
  // カード側も .ColorSwatch を使っているため、これが無いとカードの色を選んだだけで
  // メイン商品のギャラリーへスクロールしてしまう。
  const isInProductCard = (el) => !!(el && el.closest('.ProductItem'));

  const findGallery = () => {
    for (const sel of GALLERY_TARGETS) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    // Prestigeのメイン画像が「.Product__Slideshow, .Carousel」な場合も
    return document.querySelector('.Product__Slideshow, .Carousel, .product__media') || null;
  };

  const scrollToTopOrGallery = () => {
    if (!isMobile()) return;
    const target = findGallery();
    const top = target
      ? window.pageYOffset + target.getBoundingClientRect().top - OFFSET_PX
      : 0;
    window.scrollTo({ top, behavior: 'smooth' });
    log('scrolled', { to: target ? 'gallery' : 'top', y: top });
  };

  // “色”かどうかの判定を広めに
  const isColorOption = (el) => {
    if (!el) return false;
    const nm = (el.getAttribute('name') || el.dataset.optionName || el.getAttribute('aria-label') || '').toLowerCase();
    const txt = ((el.closest('label')?.textContent) || '').toLowerCase();
    const wrap = el.closest('[data-swatch],[data-color-swatch],[data-option-swatch],.swatch,.product-form__swatch,.ColorSwatch,.ProductForm__Option');
    return (
      /color|colour|カラー/.test(nm) ||
      /color|colour|カラー/.test(txt) ||
      !!wrap?.matches('[data-color-swatch],.ColorSwatch') // Prestige系
    );
  };

  // ===== イベント拾い：テーマの差を網羅 =====
  const onVariantEvent = (e, tag) => {
    if (!isMobile()) return;
    const src = e?.target || document.activeElement;
    if (isInProductCard(src)) return;
    if (isColorOption(src)) {
      log('event', tag, src);
      scrollToTopOrGallery();
    } else {
      // どのオプションか分からないテーマ向けに一旦スクロールしてしまう設定にしたい場合は下記を解除
      // scrollToTopOrGallery();
    }
  };

  // よくあるイベント名（Dawn/Prestige/他）
  ['variantChange', 'variant:change', 'product:variant-change', 'change:variant'].forEach(ev => {
    document.addEventListener(ev, (e) => onVariantEvent(e, ev), { passive: true });
  });

  // input/select 直接
  document.addEventListener('change', (e) => {
    if (!isMobile()) return;
    const t = e.target;
    if (!t) return;
    if (isInProductCard(t)) return;
    if (t.matches('input[type="radio"],input[type="button"],button,select')) {
      if (isColorOption(t)) {
        log('change (input/select)', t);
        scrollToTopOrGallery();
      }
    }
  }, { passive: true });

  // クリック（Prestigeの色チップがbutton/labelでchangeを出さないケース対策）
  document.addEventListener('click', (e) => {
    if (!isMobile()) return;
    const t = e.target.closest('button,label,.ColorSwatch,.swatch__item');
    if (isInProductCard(t)) return;
    if (t && isColorOption(t)) {
      log('click', t);
      // 一部テーマは即座に画像切替→次フレームでスクロールする方が自然
      requestAnimationFrame(scrollToTopOrGallery);
    }
  }, { passive: true });

  // ===== 最終保険：variant id の値変化を監視（色以外でも発火するが確実）=====
  const observeVariantIdChange = () => {
    // product form 内の hidden [name="id"] が変わるのを監視
    const idInputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
    idInputs.forEach((inp) => {
      // 商品カードのフォームは対象外
      if (isInProductCard(inp)) return;
      // boot() は shopify:section:load のたびに呼ばれるため、
      // 同じ input に監視とポーリングを重ねて登録しないようにする
      if (inp.dataset.swatchScrollBound) return;
      inp.dataset.swatchScrollBound = '1';

      let last = inp.value;
      const mo = new MutationObserver(() => {
        if (inp.value !== last) {
          last = inp.value;
          log('variant id changed', last);
          scrollToTopOrGallery();
        }
      });
      mo.observe(inp, { attributes: true, attributeFilter: ['value'] });

      // 一部テーマは属性は変えずに setAttribute しない→定期チェック
      setInterval(() => {
        if (inp.value !== last) {
          last = inp.value;
          log('variant id changed (poll)', last);
          scrollToTopOrGallery();
        }
      }, 500);
    });
  };

  const boot = () => {
    if (DEBUG) log('boot');
    observeVariantIdChange();
  };

  // セクション再描画（Shopify editor/動的ロード）にも対応
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
